// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rn_a bhy_a bhy_r bhy_sb bhy_ry bhy_rz","GroupsGrid__row__item":"rn_b bhy_be bhy_rz"};